/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateConditionsRequestCompaniesInner } from './UpdateConditionsRequestCompaniesInner';
import {
    UpdateConditionsRequestCompaniesInnerFromJSON,
    UpdateConditionsRequestCompaniesInnerFromJSONTyped,
    UpdateConditionsRequestCompaniesInnerToJSON,
    UpdateConditionsRequestCompaniesInnerToJSONTyped,
} from './UpdateConditionsRequestCompaniesInner';

/**
 * 経済条件一括更新リクエスト
 * @export
 * @interface UpdateConditionsRequest
 */
export interface UpdateConditionsRequest {
    /**
     * 経済条件
     * @type {Array<UpdateConditionsRequestCompaniesInner>}
     * @memberof UpdateConditionsRequest
     */
    companies: Array<UpdateConditionsRequestCompaniesInner>;
}

/**
 * Check if a given object implements the UpdateConditionsRequest interface.
 */
export function instanceOfUpdateConditionsRequest(value: object): value is UpdateConditionsRequest {
    if (!('companies' in value) || value['companies'] === undefined) return false;
    return true;
}

export function UpdateConditionsRequestFromJSON(json: any): UpdateConditionsRequest {
    return UpdateConditionsRequestFromJSONTyped(json, false);
}

export function UpdateConditionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateConditionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': ((json['companies'] as Array<any>).map(UpdateConditionsRequestCompaniesInnerFromJSON)),
    };
}

export function UpdateConditionsRequestToJSON(json: any): UpdateConditionsRequest {
    return UpdateConditionsRequestToJSONTyped(json, false);
}

export function UpdateConditionsRequestToJSONTyped(value?: UpdateConditionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companies': ((value['companies'] as Array<any>).map(UpdateConditionsRequestCompaniesInnerToJSON)),
    };
}

